import React from 'react';
import { Offline, Online } from 'react-detect-offline';

import { specials } from './texts';

export default class OfflinePage extends React.PureComponent {
	constructor(props) {
		super(props);
		this.config = this.getLinkConfig();
	}
	componentDidMount() {
		if (navigator.onLine) {
			this.goOnline();
		} else {
			window.addEventListener('online', this.goOnline.bind(this));
		}
  }
	getLinkConfig() {
		const [key] = Object.entries(specials).find(([key, value]) => value.shortName === this.props.shortName);
		return specials[key];
	}
	goOnline() {
		window.location.replace(this.config.href);
	}
	render() {
		const { longName } = this.config;
		return (
			<div className="text big">
				<p>
					<Offline>
						<b>When you go back online</b>, we’ll send you to {longName}.
					</Offline>
					<Online>
						Forwarding you to<br />
						{longName}<br />
						This should take less than 10 seconds.<br />
					</Online>
				</p>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/Forwarder.js